module.exports = __webpack_public_path__ + "img/screen.a0b002c7.png";